import { useTranslation } from "react-i18next";
import { isToday, differenceInDays } from "date-fns";

import { useRootDispatch, useRootSelector } from "store";
import { updateSlide } from "store/common/common-slice";
import {
  selectAllAccounts,
  selectedAccountInfo,
} from "store/account/account-selector";

import classes from "./AccountOverview.module.scss";

export const AccountOverview: React.FC<{}> = () => {
  const { t } = useTranslation(["common"]);
  const dispatch = useRootDispatch();
  const allAccounts = useRootSelector(selectAllAccounts);
  const accountInfo = useRootSelector(selectedAccountInfo);

  const initialValue = {
    total_account: 0,
    total_due: 0,
    dueIn5: 0,
    dueToday: 0,
  };

  const pageObj = allAccounts.reduce((previousValue, currentValue) => {
    const due5Res = differenceInDays(
      new Date(currentValue.dueDate),
      new Date(),
    );
    previousValue.total_due += currentValue.amountDue;
    previousValue.dueToday += isToday(new Date(currentValue.dueDate)) ? 1 : 0;
    previousValue.dueIn5 += due5Res >= 0 && due5Res <= 5 ? 1 : 0;
    return previousValue;
  }, initialValue);

  return (
    <section className={classes.Wrapper}>
      {/* <h3 style={{ display: "none" }}>{t("common:account_details")}</h3> */}
      <div className={classes.Container}>
        <div className={[classes.Module, classes.AccountNumber].join(" ")}>
          <p className={classes.Label}>{t("common:account_label")} #</p>
          <p className={classes.Value}>{accountInfo?.accountNumber}</p>
        </div>
        <div className={classes.AccountDetail}>
          <div className={classes.Module}>
            <p className={classes.Label}>{t("common:total_accounts")}</p>
            <p className={classes.Value}>{allAccounts.length}</p>
          </div>
          <div className={classes.Module}>
            <p className={classes.Label}>{t("common:total_due")}</p>
            <p className={classes.Value}>
              {t("common:currency_format", { value: pageObj.total_due })}
            </p>
          </div>
          <div className={classes.Module}>
            <p className={classes.Label}>{t("common:bill_due_five_days")}</p>
            <p className={classes.Value}>{pageObj.dueIn5}</p>
          </div>
          <div className={classes.Module}>
            <p className={classes.Label}>{t("common:bill_due_today")}</p>
            <p className={classes.Value}>{[pageObj.dueToday]}</p>
          </div>
        </div>
        <div className={[classes.Module, classes.SwitchAccount].join(" ")}>
          <p className={classes.Label}>
            <ft-button
              label={t("common:switch_account")}
              icon="manage_accounts"
              unelevated
              onClick={() => dispatch(updateSlide({ id: "ManageAccount" }))}
            ></ft-button>
          </p>
          <p className={classes.Value}></p>
        </div>
      </div>
    </section>
  );
};
